import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./firebase";
import { Provider } from "react-redux";
import store from "./store";
import "./utils/i18";
import TagManager from "react-gtm-module";

TagManager.initialize({ gtmId: "GTM-NF6PXLMP" });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <StrictMode>
      <App />
    </StrictMode>
  </Provider>
);
